import type { PatternFormatProps } from "react-number-format";
import { PatternFormat } from "react-number-format";
import React, { forwardRef } from "react";
import Input, { InputProps } from "@components/UI/Input";

type InputWithMaskProps<T> = {
	inputProps: Omit<InputProps, "defaultValue" | "type" | "value">;
	maskProps: Omit<PatternFormatProps<T>, "label">;
	ref?: HTMLInputElement;
};

const InputWithMask = forwardRef<HTMLInputElement, InputWithMaskProps<InputProps>>(
	({ inputProps, maskProps }, ref) => {
		return <PatternFormat {...maskProps} {...inputProps} customInput={Input} getInputRef={ref} />;
	}
);

InputWithMask.displayName = "InputWithMask";

export default InputWithMask;
